
  import { computed, defineComponent, onMounted, ref } from 'vue';
  import LinkButton from '@/ui/components/checklist/LinkButton.vue';
  import { Button } from '@/ui/components/Button';
  import { router } from '@/ui/routes';
  import TabletFrame from '@/_legacy/components/TabletFrame.vue';
  import ConductInspectionPreview from '@/_legacy/components/ConductInspection/ConductInspectionPreview.vue';
  import { useAiFileUpload } from '@/ui/concerns/checklist/useAiFileUpload';
  import { useChecklistSessionStorage } from '@/ui/concerns/useChecklistSessionStorage';
  import { InputField } from '@/ui/components/form';
  import { ConfirmationModal } from '@/ui/components/modals/ConfirmationModal';
  import { Icon } from '@/ui/components/icon/Icon';
  import { Tooltip } from '@/ui/components/Tooltip';
  import { hasAiBalance } from '@/ui/auth/auth';

  export default defineComponent({
    components: {
      ConfirmationModal,
      LinkButton,
      InputField,
      Button,
      TabletFrame,
      // @ts-ignore
      ConductInspectionPreview,
      Icon,
      Tooltip,
    },

    setup() {
      const {
        aiPrompt,
        aiPromptIdeas,
        loading,
        clearPreview,
        aiTemplate,
        getPromptIdeasTask,
        onGenerateTemplateClick,
        onUseThisTemplateClick,
        onCustomizeTemplateClick,
      } = useAiFileUpload();

      const hideModal = () => { leaveModalShow.value = false; };
      const showModal = () => { leaveModalShow.value = true; };
      const leaveModalShow = ref(false);
      const canContinue = computed(() => aiPrompt.value.length && aiTemplate.value && !loading.value);
      const { exitAction, cleanAiForm } = useChecklistSessionStorage();

      onMounted(() => {
        cleanAiForm();
        getPromptIdeasTask.run();
      });

      const onGoBack = () => {
        router.push({ name: 'checklistChooseMethod' });
      };
      const onPromptClick = (text: string) => {
        aiPrompt.value = text; onGenerateTemplateClick();
      };

      const onQuit = () => {
        if (!aiPrompt.value.length && !aiTemplate.value) {
          exitAction();

          return;
        }

        showModal();
      };

      const onUseThisTemplate = () => onUseThisTemplateClick(true, false);
      const onCustomizeTemplate = () => onCustomizeTemplateClick(true, false);

      return {
        canContinue,
        onGoBack,
        onQuit,
        clearPreview,
        loading,
        aiTemplate,
        aiPrompt,
        aiPromptIdeas,
        onPromptClick,
        onGenerateTemplateClick,
        onUseThisTemplate,
        onCustomizeTemplate,
        leaveModalShow,
        hideModal,
        exitAction,
        hasAiBalance,
      };
    },
  });
